
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_17c0g_98",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_17c0g_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_17c0g_120",
  "icon": "awsui_icon_gwq0h_17c0g_134",
  "root": "awsui_root_gwq0h_17c0g_152",
  "expanded": "awsui_expanded_gwq0h_17c0g_170",
  "icon-container": "awsui_icon-container_gwq0h_17c0g_174",
  "trigger": "awsui_trigger_gwq0h_17c0g_120",
  "trigger-default": "awsui_trigger-default_gwq0h_17c0g_189",
  "trigger-footer": "awsui_trigger-footer_gwq0h_17c0g_192",
  "trigger-navigation": "awsui_trigger-navigation_gwq0h_17c0g_198",
  "trigger-container": "awsui_trigger-container_gwq0h_17c0g_212",
  "header": "awsui_header_gwq0h_17c0g_222",
  "header-container": "awsui_header-container_gwq0h_17c0g_225",
  "header-container-button": "awsui_header-container-button_gwq0h_17c0g_241",
  "header-navigation": "awsui_header-navigation_gwq0h_17c0g_249",
  "content": "awsui_content_gwq0h_17c0g_98",
  "content-default": "awsui_content-default_gwq0h_17c0g_285",
  "content-footer": "awsui_content-footer_gwq0h_17c0g_288",
  "content-expanded": "awsui_content-expanded_gwq0h_17c0g_291",
  "focusable": "awsui_focusable_gwq0h_17c0g_295"
};
  